import { render, staticRenderFns } from "./MiniTabbar.vue?vue&type=template&id=75d4b2f9"
import script from "./MiniTabbar.vue?vue&type=script&lang=js"
export * from "./MiniTabbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports